import React from "react";
import PdfBase from "./PdfBase";
import { generateServiceIncomePdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  schedule,
  company,
  otherIncomeRows,
  expensesRows,
  totalOtherIncome,
  totalExpenses,
  netIncome,
  shareOfExpenses,
  notes,
  reviewNotes
}) => {
  const sharedArgs = [
    schedule,
    company,
    otherIncomeRows,
    expensesRows,
    totalOtherIncome,
    totalExpenses,
    netIncome,
    shareOfExpenses,
    notes,
    reviewNotes
  ];
  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateServiceIncomePdf(forView, ...sharedArgs)
        }
        downloadName={schedule.name || schedule.type}
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateServiceIncomePdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
